export let FormActionsAlign = /*#__PURE__*/function (FormActionsAlign) {
  FormActionsAlign["LEFT"] = "left";
  FormActionsAlign["CENTER"] = "center";
  FormActionsAlign["RIGHT"] = "right";
  return FormActionsAlign;
}({});
//# sourceMappingURL=constants.js.map